import state from "./moduleCreditPacksManagementState";
import mutations from "./moduleCreditPacksManagementMutations";
import actions from "./moduleCreditPacksManagementActions";

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
